app.controller('AccountDetailController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const siteHelper = $rootScope.site_helper;

    $scope.view_model = {
        form_disabled: false,
        new_email_address: "",
        current_password: "",
        new_password: "",
        confirm_new_password: "",
        despatch_note: $rootScope.model.account.customer_data ? $rootScope.model.account.customer_data.despatch_note : "",
        webquote_defaults: $rootScope.model.account.user_data.webquote_defaults ? $rootScope.model.account.user_data.webquote_defaults : {},
        dealer_locator: $rootScope.model.account.customer_data && $rootScope.model.account.customer_data.dealer_locator ? $rootScope.model.account.customer_data.dealer_locator : {},
    }

    $scope.changeEmailAddress = function (validateFormCallback) {
        $scope.view_model.form_disabled = true;
        $rootScope.service.account.changeEmailAddress($scope.view_model.new_email_address, function (success, data, messages) {
            $scope.view_model.form_disabled = false;
            if (success) {
                siteHelper.addSuccessMessage("A confirmation email has been sent to your new " +
                    "email address, to complete the change please click on the link within that email!", messages);
            }
            validateFormCallback(success, messages);
        });
    }

    $scope.changePassword = function (validateFormCallback) {

        if ($scope.view_model.new_password !== $scope.view_model.confirm_new_password) {
            validateFormCallback(false, siteHelper.addErrorMessage("Sorry your passwords do not match!"));
            return;
        }
        $scope.view_model.form_disabled = true;
        $rootScope.service.account.changePassword($scope.view_model.current_password, $scope.view_model.new_password, function (success, data, messages) {
            $scope.view_model.form_disabled = false;
            if (success) {
                siteHelper.addSuccessMessage("Password successfully updated!", messages);
            }
            validateFormCallback(success, messages);
        });
    }

    $scope.changeDespatchNote = function (validateFormCallback) {

        $scope.view_model.form_disabled = true;
        $rootScope.service.account.changeDespatchNote($scope.view_model.current_password, function (success, data, messages) {
            $scope.view_model.form_disabled = false;
            if (success) {
                siteHelper.addSuccessMessage("A request to update your Delivery Instructions " +
                    "have been successfully sent and will be updated as soon as possible!", messages);
            }
            validateFormCallback(success, messages);
        });
    }

    $scope.saveQuoteDefaults = function (validateFormCallback) {

        $scope.view_model.form_disabled = true;
        $rootScope.service.order_quote.saveQuoteDefaults($scope.view_model.webquote_defaults, function (success, data, messages) {
            $scope.view_model.form_disabled = false;
            validateFormCallback(success, messages);
        })

    };

    $scope.updateDealerLocator = function (validateFormCallback) {
        $scope.view_model.form_disabled = true;
        $rootScope.service.account.updateDealerLocator($scope.view_model.dealer_locator, function (success, data, messages) {
            $scope.view_model.form_disabled = false;
            if (success) {
                siteHelper.addSuccessMessage("Dealer Locator data successfully updated! A " +
                    "member of staff will check your data and update it as soon as possible.", messages);
            }
            validateFormCallback(success, messages);
        });
    }

}]);